import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';
import { SINGLE_FLIGHT } from './single-flight.token';
import { buildSingleFlightKey } from './single-flight-key';

@Injectable()
export class SingleFlightInterceptor implements HttpInterceptor {
  private readonly inflightRequests = new Map<string, Observable<HttpEvent<unknown>>>();

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.context.get(SINGLE_FLIGHT)) {
      return next.handle(request);
    }

    const key = buildSingleFlightKey(request);

    const existingRequest = this.inflightRequests.get(key);

    if (existingRequest) {
      return existingRequest;
    }

    const request$ = next.handle(request).pipe(
      finalize(() => {
        this.inflightRequests.delete(key);
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.inflightRequests.set(key, request$);

    return request$;
  }
}
